import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ operatorParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `labour/getSearched`,
      params: operatorParams,
    });
    const allOperator = data;
    yield put(Actions.setAll({ allOperator }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchLabours() {
  try {
    const { data } = yield call(api.get, {
      route: 'labour',
    });
    const laboursData = data;
    yield put(Actions.setLaboursData({ laboursData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateOperator({ operatorData, actionName, operatorParams, caller }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `labour`,
      data: operatorData,
    });

    yield put(Actions.fetchAll({ operatorParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.OPERATORS_CREATED
        : CONSTANT_VARIABLES.OPERATORS_UPDATED,
      ''
    );
    if (caller) {
      console.log('caller', caller);
      caller();
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteOperator({ id, operatorParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `labour/${id}`,
    });
    yield put(Actions.fetchAll({ operatorParams }));
    notification('success', CONSTANT_VARIABLES.OPERATORS_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* isOperatorIdReserved({ id, callback }) {
  try {
    const response = yield call(api.get, {
      route: 'labour/islabourexists/' + id,
    });
    const isReserved = response.data;
    if (isReserved) {
      callback(`Employee no. ${id} already exist`);
    } else {
      callback();
    }
    yield put(Actions.setIsOperatorIdReserved({ isReserved }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

function* fetchOperatorsByDepartmentId({ departmentId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'labour/department/' + departmentId,
    });
    const departmentOperators = data;
    yield put(Actions.setOperatorsByDepartmentId({ departmentOperators }));
  } catch (err) {
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchFactoryLabours({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'labour/getlaboursbyfactoryid/' + factoryId,
    });
    const factoryLaboursData = data;
    yield put(Actions.setFactoryLabours({ factoryLaboursData }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* fetchFactoryLaboursById({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'labour/getfactorylaboursbyid/' + factoryId,
    });
    const factoryLaboursDataById = data;
    yield put(Actions.setFactoryLaboursById({ factoryLaboursDataById }));
  } catch (err) {
    console.warn(err); // Handle exception
    notification('error', err.toString(), '');
  }
}

function* addOperatorSkill({ skillParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: 'labourskill/',
      data: skillParams,
    });
    const operatorParams = { operatorId: skillParams.labourId, toolId: 0 };
    yield put(Actions.fetchOperatorSkills({ operatorParams }));
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.OPERATOR_SKILL_CREATED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* updateOperatorSkill({ skill }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: 'labourskill/',
      data: skill,
    });
    const operatorParams = { operatorId: skill.labourId, toolId: 0 };
    yield put(Actions.fetchOperatorSkills({ operatorParams }));
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.OPERATOR_SKILL_UPDATED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchOperatorSkills({ operatorParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: 'labourskill/getskill/' + operatorParams.operatorId + '/' + operatorParams.toolId,
    });
    const operatorSkills = data;
    yield put(Actions.setOperatorSkills({ operatorSkills }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteOperatorSkill({ skillId, operatorId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `labourskill/${skillId}`,
    });
    const operatorParams = {
      operatorId: operatorId,
    };
    yield put(Actions.fetchOperatorSkills({ operatorParams }));
    notification('success', CONSTANT_VARIABLES.OPERATOR_SKILL_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* isOperatorAssigned({ operatorId }) {
  try {
    yield put(Actions.setOperatorAssignedLoader({ operatorAssignedLoader: true }));
    const { data } = yield call(api.get, {
      route: `joblabour/IsOperatorAssinged/${operatorId}`,
    });
    const operatorAssigned = data;
    yield put(Actions.setOperatorAssigned({ operatorAssigned }));
    yield put(Actions.setOperatorAssignedLoader({ operatorAssignedLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_FACTORY_LABOURS, fetchFactoryLabours),
    takeLatest(ActionTypes.FETCH_FACTORY_LABOURS_BY_ID, fetchFactoryLaboursById),
    takeLatest(ActionTypes.ADD_OR_UPDATE_OPERATOR, addorUpdateOperator),
    takeLatest(ActionTypes.DELETE_OPERATOR, deleteOperator),
    takeLatest(ActionTypes.IS_OPERATOR_ID_RESERVED, isOperatorIdReserved),
    takeLatest(ActionTypes.FETCH_LABOURS, fetchLabours),
    takeLatest(ActionTypes.FETCH_OPERATORS_BY_DEPARTMENT_ID, fetchOperatorsByDepartmentId),
    takeLatest(ActionTypes.FETCH_OPERATOR_SKILLS, fetchOperatorSkills),
    takeLatest(ActionTypes.DELETE_OPERATOR_SKILL, deleteOperatorSkill),
    takeLatest(ActionTypes.ADD_OPERATOR_SKILL, addOperatorSkill),
    takeLatest(ActionTypes.UPDATE_OPERATOR_SKILL, updateOperatorSkill),
    takeLatest(ActionTypes.IS_OPERATOR_ASSIGNED, isOperatorAssigned),
  ]);
}
